import { useDispatch, useSelector } from "react-redux";
import LoadingBtn from "../../../Loading/components/LoadingBtn/LoadingBtn";
import {
  createContractAction,
  updateContractAction,
} from "../../../../redux/actions/contractActions";

export default function SubmitBtn({
  formik,
  modalData,
  funcType,
  selectedFile,
}) {
  const dispatch = useDispatch();
  const { contractModalLoading } = useSelector((state) => state.contractModal);

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("name", modalData.name);
    formData.append("contractType", modalData.contractType);

    if (selectedFile) {
      formData.append("file", selectedFile); // controller-dəki field adı: "file"
    }

    if (funcType === "create") {
      dispatch(createContractAction(formData)); // ← action-a formData göndər
    } else {
      formData.append("isActive", modalData.isActive);
      dispatch(updateContractAction(modalData._id, formData));
    }
  };

  return (
    <div className="create-update-modal-btn">
      <button
        disabled={
          !(modalData?.contractType && modalData?.name && !contractModalLoading)
        }
        onClick={handleSubmit}
      >
        {contractModalLoading ? (
          <LoadingBtn />
        ) : funcType === "update" ? (
          "Yenilə"
        ) : (
          "Yarat"
        )}
      </button>
    </div>
  );
}
